import BreadcrumbLink from '@/shared/ui/components/BreadcrumbLink';
import type { RoutePathDefinition } from '../../types';

export const providerSectionRoutes: RoutePathDefinition[] = [
  // 2024-02-15 Commented this route since we currently use new patient onboard flow
  // {
  //   path: 'manage',
  //   Component: Manage,
  //   handle: {
  //     crumb: () => <BreadcrumbLink>Manage</BreadcrumbLink>
  //   }
  // },
  {
    path: 'update-profile',
    lazy: () => import('@/pages/providers/ui/PatientProfile').then(m => ({ Component: m.default })),
    handle: {
      crumb: () => <BreadcrumbLink>Update</BreadcrumbLink>
    }
  },
  {
    path: 'insurance-plans',
    lazy: () => import('@/pages/providers/ui/PatientInsurancePlans').then(m => ({ Component: m.default })),
    handle: {
      crumb: () => <BreadcrumbLink>Insurance Plans</BreadcrumbLink>
    }
  },
  {
    path: 'client-org-store',
    lazy: () => import('@/pages/providers/ui/manageClientOrgAndStore').then(m => ({ Component: m.default })),
    handle: {
      crumb: () => <BreadcrumbLink>Organizations and Stores</BreadcrumbLink>
    }
  }
];
